// extracted by mini-css-extract-plugin
module.exports = {"mustTryCardLoading":"components-MustTryCard-MustTryCard__mustTryCardLoading--2E8PA"};